import { useEffect, useRef, useState } from 'react'

import { AnimateBox } from '../../components/animate-box'
import { STATIC_OBS_URL } from '../../consts'

import type { NewsListProps } from '../news'

interface SectionDProps {
  data: NewsListProps['data']
  title: string
}
export const SectionD = ({ title, data }: SectionDProps) => {
  const el = useRef<HTMLDivElement>(null)
  const handleClick = (type: string) => {
    // const size = 1440
    const size = 480
    if (type === 'l') {
      el.current?.scrollBy({
        left: -size,
        behavior: 'smooth'
      })
    } else {
      el.current?.scrollBy({
        left: size,
        behavior: 'smooth'
      })
    }
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [bodyWidth, setBodyWidth] = useState(1420)

  useEffect(() => {
    setBodyWidth(document.body.clientWidth)
  }, [])

  return (
    <>
      <div className='title-box'>
        <AnimateBox tagName='h2'>{title}</AnimateBox>
        <AnimateBox animateDelay={0.5} tagName='p'>
          聚焦工业软件前沿动态，展现世冠风采
        </AnimateBox>
      </div>
      <div className='scroll-c' ref={el}>
        <ul className='inner'>
          {data.map(({ title, thumbnail, description, url, _id }, index) => {
            const targetUrl = url !== '' ? url : `/news/${_id}`
            const targetThumbnail = `${STATIC_OBS_URL}/website/${thumbnail}`
            const classArr = ['card', 'h600', 'w460', 'border']
            classArr.push('p162-334')
            const animateDelay = index >= 4 ? 0 : 1 + index * 0.2
            // const animateDelay = 0.2
            return (
              <AnimateBox animateDelay={animateDelay} className={classArr.join(' ')} key={_id}>
                <div className='img'>
                  <div className='pic' style={{ backgroundImage: `url(${targetThumbnail})` }} />
                </div>
                <div className='info'>
                  <h5 className='clamp-1'>
                    <a href={targetUrl}>{title}</a>
                  </h5>
                  <p className='clamp-2'>{description}</p>
                  <a className='look-more b40' href={targetUrl}>
                    <span>了解更多</span>
                  </a>
                </div>
              </AnimateBox>
            )
          })}
        </ul>
      </div>
      <div className='btnlr-com'>
        <button
          className='arrow-icon dark-left'
          onClick={() => {
            handleClick('l')
          }}
        />
        {/* <button
          className='arrow-icon dark-left-grey'
          onClick={() => {
            handleClick('l')
          }}
        /> */}
        <button
          className='arrow-icon dark-right'
          onClick={() => {
            handleClick('r')
          }}
        />
        {/* <button
          className='arrow-icon dark-right-grey'
          onClick={() => {
            handleClick('r')
          }}
        /> */}
      </div>
    </>
  )
}
